<script setup>
// IMPORTS
import { computed, ref } from "vue";

// DEPENDENCIES
const auth = useAuth();
const { user } = useAuth();

// TYPES

// INJECT

// MODEL

// CONSTANTS

// PROPS, EMITS

// REFS
const op = ref();

const items = ref([
  {
    label: "Logout",
    command: () => {
      auth.logout();
    },
  },
]);

// COMPUTED
const userInitial = computed(() => {
  return user.value.name ? user.value.name.charAt(0).toUpperCase() : "U";
});

// COMPONENT METHODS AND LOGIC
const toggle = (event) => {
  op.value.toggle(event);
};

// PROVIDE, EXPOSE

// WATCHERS

// LIFECYCLE METHODS (https://vuejs.org/api/composition-api-lifecycle.html)
</script>

<template>
  <div
    class="ml-auto flex cursor-pointer items-center gap-1"
    @click="toggle"
  >
    <span class="heading-sm">{{ user.name }}</span>
    <Avatar
      icon="pi pi-user"
      :label="userInitial"
      size="normal"
      class="m-1 text-gray-400"
      style="border: 2px solid white"
      shape="circle"
    />
  </div>

  <Popover
    ref="op"
    class="p-component p-menu-overlay without-arrow topbar-user"
  >
    <div
      style="width: 488px"
      class="flex flex-col gap-3 p-4"
    >
      <div class="flex flex-row gap-4">
        <Avatar
          icon="pi pi-user"
          :label="userInitial"
          size="xlarge"
          class="m-1 text-gray-400"
          style="border: 2px solid white; width: 96px; height: 96px"
          shape="circle"
        />
        <div class="flex flex-col gap-4">
          <span class="heading-sm">{{ user.name }}</span>
          <div class="flex items-center gap-2">
            <img
              :src="`/icons/roles/${user.role}.svg`"
              alt="Role icon"
              class="h-5 w-5"
            />
            {{ $t(`roles.${user.role}`) }}
          </div>
          <span>{{ user.email }}</span>
        </div>
      </div>
      <div
        v-for="item in items"
        :key="item.label"
        class="flex w-full flex-row items-center gap-2"
      >
        <Menu
          :model="items"
          class="w-full"
        />
      </div>
    </div>
  </Popover>
</template>

<style>
.p-popover.without-arrow:before,
.p-popover.without-arrow:after {
  display: none;
}

.p-popover.topbar-user:after {
  border-bottom-color: var(--color-dark-gray-2000) !important;
}

.topbar-user .p-menu {
  background-color: var(--color-dark-gray-2000) !important;
  color: #fff !important;
  border: none !important;
}

.topbar-user .p-menu .p-menuitem {
  border-top: 1px solid #353a40 !important;
}
.p-menu-item:not(.p-disabled) .p-menu-item-content:hover,
.topbar-user .p-menu .p-menuitem:hover {
  background-color: var(--color-dark-gray-1900) !important;
}
</style>
